import { gql } from 'graphql-request'

export namespace BookableDuplicatesMutations {
  export function updateBookablePersonDuplicateDecision() {
    return gql`
      mutation updateBookablePersonDuplicateDecision(
        $bookablePersonDuplicateDecision: BookablePersonDuplicateDecisionMutation!
      ) {
        updateBookablePersonDuplicateDecision(bookablePersonDuplicateDecision: $bookablePersonDuplicateDecision) {
          bookablePersonType
          bookablePersonId
        }
      }
    `
  }
}
